/**
 * @generated SignedSource<<8ad8ccebd103a9c9dc8732c3a9fcce65>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type versionList_softwareReleasesMoveIssuesBetweenVersions_jiraIssue$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraIssue" | "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraIssue" | "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersions">;
  readonly " $fragmentType": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraIssue";
};
export type versionList_softwareReleasesMoveIssuesBetweenVersions_jiraIssue$key = {
  readonly " $data"?: versionList_softwareReleasesMoveIssuesBetweenVersions_jiraIssue$data;
  readonly " $fragmentSpreads": FragmentRefs<"versionList_softwareReleasesMoveIssuesBetweenVersions_jiraIssue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "versionList_softwareReleasesMoveIssuesBetweenVersions_jiraIssue",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "FragmentSpread",
      "name": "moveIssueToOtherVersion_softwareReleasesMoveIssuesBetweenVersions_jiraIssue"
    },
    {
      "kind": "FragmentSpread",
      "name": "removeIssueFromVersion_softwareReleasesMoveIssuesBetweenVersions"
    },
    {
      "kind": "FragmentSpread",
      "name": "issueWarning_softwareReleasesMoveIssuesBetweenVersions_jiraIssue"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "9dbec216043d11ab3ebbdd111e565798";

export default node;
